import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import ConnectedJoinTeamButton from "./ConnectedJoinTeamButton";
import TeamFullMessage from "./TeamFullMessage";
import "./SearchRow.scss";

const SearchRow = ({ captains = [], id, teamFull = false, title }) => (
    <div className="col col--12 col--no-top-gutter team-modal-search-row">
        <div className="team-modal-search-row__content">
            <div className="grid">
                <div className="col col--8 -centered--vertically">
                    <div className="team-modal-search-row__content--title intro-text">
                        {title}
                    </div>
                    {captains.length > 0 && (
                        <p>
                            <Icon
                                className="-margin-right--10"
                                glyph="crown-regular"
                                type="FontAwesome"
                            />{" "}
                            {captains.map((captain, i) => {
                                // eslint-disable-next-line no-shadow
                                const { id, name } = captain;
                                return (
                                    <React.Fragment key={id}>
                                        {i > 0 && ", "}
                                        <small>{name}</small>
                                    </React.Fragment>
                                );
                            })}
                        </p>
                    )}
                </div>
                <div className="col col--4 -padding-right--10">
                    {teamFull ? (
                        <TeamFullMessage />
                    ) : (
                        <ConnectedJoinTeamButton id={id} />
                    )}
                </div>
            </div>
        </div>
    </div>
);

SearchRow.propTypes = {
    captains: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    teamFull: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default SearchRow;
